import { createAction } from '@reduxjs/toolkit';

export const setPageError = createAction('SET_PAGE_ERROR');
export const clearPageError = createAction('CLEAR_PAGE_ERROR');